export const UPDATE_STEP = 'UPDATE_STEP';
export const ADD_ALERT = 'ADD_ALERT';
export const CLEAR_ALERT = 'CLEAR_ALERT';
export const UPDATE_CURRENT_ATHLETE = 'UPDATE_CURRENT_ATHLETE';
export const UPDATE_SUGGESTED_FRIENDS = 'UPDATE_SUGGESTED_FRIENDS';

export default {
  UPDATE_STEP,
  ADD_ALERT,
  CLEAR_ALERT,
  UPDATE_CURRENT_ATHLETE
};
